import { PropsWithChildren } from 'react';
import { Button, MantineProvider } from '@mantine/core';
import { IconLogout } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import styles from './NavbarPage.module.css';
import { mantineDarkTheme } from '../../theme';
import { AppRegion, getAppRegionFlag, useAppRegion } from '../../contexts';
import { useRegionalAuth } from '../../auth';

export function NavbarPage({ children }: PropsWithChildren<unknown>) {
  const { region } = useAppRegion();
  const regionalAuth = useRegionalAuth();
  const { t } = useTranslation();

  return (
    <div className={styles['pageContainer']}>
      <MantineProvider theme={mantineDarkTheme}>
        <div className={styles['navbarContainer']}>
          <img className={styles['logo']} src='/tesla_logo.svg' alt='Tesla' />
          <Button
            leftIcon={getAppRegionFlag(region)}
            onClick={regionalAuth[region ?? AppRegion.EU].logout}
            variant='subtle'
            color='red'
            rightIcon={<IconLogout size={14} />}
          >
            {t('navbar.logout')}
          </Button>
        </div>
      </MantineProvider>
      {children}
    </div>
  );
}
